import markItemsReadInListViewStore from '../actions/triage/markItemsReadInListViewStore';
import markItemsAsReadStoreUpdate from 'owa-mail-actions/lib/triage/markItemsAsReadStoreUpdate';
import { orchestrator } from 'satcheljs';
export default orchestrator(markItemsAsReadStoreUpdate, function (actionMessage) {
    var itemIds = actionMessage.itemIds, isReadValue = actionMessage.isReadValue;
    markItemsReadInListViewStore(itemIds, isReadValue);
});
//# sourceMappingURL=markItemsAsReadStoreUpdateOrchestrator.js.map